import { render } from "./EditProfileModal.vue?vue&type=template&id=c7b9df9e&scoped=true"
import script from "./EditProfileModal.vue?vue&type=script&lang=js"
export * from "./EditProfileModal.vue?vue&type=script&lang=js"

import "./EditProfileModal.vue?vue&type=style&index=0&id=c7b9df9e&scoped=true&lang=css"
import "@/assets/user-shared.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b9df9e"]])

export default __exports__